// src/data/customCocktails/index.js
/** @typedef {import('../../types/cocktails').Cocktail} Cocktail */
/** @typedef {import('../../types/cocktails').MethodType} MethodType */
import { catalogue } from './catalogue';
import { stockOnly } from './stockOnly';
import { baseInventory, listBaseOptions, listAllCocktails } from './inventory';

const glassIconMap = {
  'タンブラー': '🍹',
  'コリンズグラス': '🍹',
  'カクテルグラス': '🍸',
  'ロックグラス': '🥃',
  'オールドファッショングラス': '🥃',
  'ワイングラス': '🍷',
  'マグカップ': '🍺',
  'マルガリータグラス': '🍸',
  'オールドファッション': '🥃',
  'タンブラーグラス': '🍹',
};

const MENU_CATEGORY_MAP = {
  beerBase: ['ビール'],
  brandyBase: ['ブランデー', 'アップルブランデー', 'コニャック'],
  ginBase: ['ジン'],
  vodkaBase: ['ウォッカ'],
  rumBase: ['ラム'],
  tequilaBase: ['テキーラ'],
  liqueurBase: ['カシスリキュール', 'ピーチリキュール', 'カンパリ', 'ライチリキュール', 'マリブリキュール', 'アマレット', 'グリーンティーリキュール'],
  wineBase: ['白ワイン', '赤ワイン'],
  whiskyBase: ['ウイスキー', 'バーボン', 'ライウイスキー', 'スコッチウイスキー'],
};

const allCocktails = listAllCocktails();

export const METHOD_LABELS = {
  shake: 'シェイク',
  stir: 'ステア',
  build: 'ビルド',
};

export const AVAILABLE_METHODS = [
  { value: 'shake', label: METHOD_LABELS.shake },
  { value: 'stir', label: METHOD_LABELS.stir },
  { value: 'build', label: METHOD_LABELS.build },
];

export const getCatalogue = () => catalogue;
export const getStockOnlyCocktails = () => stockOnly;
export const getAllCocktails = () => allCocktails;

export const getCocktailById = (cocktailId) =>
  allCocktails.find((cocktail) => cocktail.cocktail_id === cocktailId);

export const getCocktailsByBase = (baseIngredient) =>
  allCocktails.filter((cocktail) => cocktail.baseIngredient === baseIngredient);

export const getBaseInventory = () => baseInventory;
export const getBaseOptions = listBaseOptions;

export const deriveMenuCocktails = () => {
  const groups = {
    beerBase: [],
    brandyBase: [],
    ginBase: [],
    vodkaBase: [],
    rumBase: [],
    tequilaBase: [],
    liqueurBase: [],
    wineBase: [],
    whiskyBase: [],
  };

  const onMenu = catalogue.filter((cocktail) => cocktail.isOnCurrentMenu);

  onMenu.forEach((cocktail) => {
    const entry = {
      name: cocktail.name,
      price: cocktail.price,
      ingredients: cocktail.ingredients.map((ingredient) => ingredient.name),
      glass: glassIconMap[cocktail.glass] || '🍸',
      method: cocktail.method,
      methodRules: cocktail.methodRules,
      cocktail_id: cocktail.cocktail_id,
    };

    const targetKey = Object.keys(MENU_CATEGORY_MAP).find((key) =>
      MENU_CATEGORY_MAP[key].includes(cocktail.baseIngredient)
    );

    if (targetKey) {
      groups[targetKey].push(entry);
    }
  });

  return groups;
};

export const NORMALIZED_TASTE_TAGS = [
  'bitter',
  'citrus',
  'floral',
  'herbal',
  'rich',
  'refreshing',
  'smoky',
  'spicy',
  'sweet',
  'umami',
];

export const normalizeJapanese = (value) =>
  value ? value.normalize('NFKC').toLowerCase() : '';

export const searchCocktails = (query) => {
  if (!query) return allCocktails;
  const normalizedQuery = normalizeJapanese(query);
  return allCocktails.filter((cocktail) => {
    const name = normalizeJapanese(cocktail.name);
    const origin = normalizeJapanese(cocktail.origin || '');
    return name.includes(normalizedQuery) || origin.includes(normalizedQuery);
  });
};
